import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'can_the_trade_unions_freely_form_and_join_federations_and_confe'

export const dataPointDefinition = {
  retracedId: 'can_the_trade_unions_freely_form_and_join_federations_and_confe',
  name: 'Can the trade union(s) freely form and join federations and confederations of their choice without interference?',
  description:
    "Federations and confederations are organizations formed by and made up of trade unions.\r\r\n\r\r\nUnion presence in the facility includes the existence of a company union and/or the affiliation of workers from the company to higher level unions (such as sectoral unions).\r\r\n\r\r\nConsult applicable legal standards to determine whether there are restrictions in place that may influence the answer to this question.\r\r\n\r\r\nWorkers' organizations should have the right to form and join federations and confederations of their choosing, subject to the rules of the organizations concerned, and without any previous authorization. It is for the federations and confederations themselves to decide whether or not to accept the affiliation of a trade union, in accordance with their own constitutions and rules.\r\r\n\r\r\nIf there was no union presence in the facility during the assessment period, select the answer: Not applicable. No union presence in the facility during assessment period.",
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'union-na',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'union-na',
    },
    {
      name: 'Not applicable. No union presence in the facility during assessment period.',
      key: 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT',
      slcpIndex: 3,
      slcpOptionName: 'union-na',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'foa-cb-2--5',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12090,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
